import RestApiQuery, { ApiEndpoints } from "../helpers/rest-api-query";
import { QueryFunctionContext } from "react-query";
import { IPartType, ISimpleResponce } from "@drone-parts.garphild.pro/interfaces";

export async function getPartTypes(context: QueryFunctionContext) {
  const result = await RestApiQuery.get<ISimpleResponce<IPartType[]>>(ApiEndpoints.SprPartTypes);
  return result?.data || [];
}

export async function deletePartType(id: string) {
  const result = await RestApiQuery.del<ISimpleResponce<IPartType>>(`${ApiEndpoints.SprPartTypes}/${id}`);
  return result?.data;
}
